
import { Hierarchy_isInBusinessUnit, LocationCreateOrUpdateDto_$reflection, LocationAddress, LocationDetailDto_$reflection, Location_$reflection, LocationCreateOrUpdateDto, LocationAddress_get_empty } from "../../Shared/Location.js";
import { Cmd_batch, Cmd_none } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { toArray, filter, map, defaultArg } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { FormState__setValidationResponse_5219762A, LocationId__get_unwrap, FormState__startLoading, FormState_get_empty, RequestedValue$1 } from "../../Shared/Shared.js";
import { Msg, State } from "./Types.js";
import { getAccountSettings } from "../../Requests/Customer.js";
import { getResponsibleBusinessUnits } from "../../Requests/BusinessUnit.js";
import { Cmd_OfPromise_either } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { addPrefix, fetchWithDecoder } from "../../Communication.js";
import { Types_RequestProperties } from "../../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { tryFind, ofArray, singleton } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { Reader_$ctor_Z3F6BC7B1, Reader__Read_24524716 } from "../../fable_modules/Fable.Remoting.MsgPack.1.25.0/Read.fs.js";
import { string_type, list_type } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { concat } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { unwrapLocationId } from "../../Shared/Helper.js";
import { fetchWithDecoder as fetchWithDecoder_1, addPrefix as addPrefix_1 } from "../../CommunicationV2.js";
import { Auto_generateBoxedEncoder_437914C6, toString } from "../../fable_modules/Thoth.Json.10.4.1/Encode.fs.js";
import { forAll } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { Cmd_successToast, Cmd_errorToast } from "../../Components/Toast.js";
import { Cmd_ofEffect } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { RouterModule_nav } from "../../fable_modules/Feliz.Router.4.0.0/Router.fs.js";

export const emptyLocation = new LocationCreateOrUpdateDto("", "", LocationAddress_get_empty(), undefined, undefined);

function updateAddress(setAddress, state) {
    const matchValue = state.Form;
    if (matchValue.tag === 0) {
        return [state, Cmd_none()];
    }
    else {
        const form = matchValue.fields[0];
        return [new State(new RequestedValue$1(1, [new LocationCreateOrUpdateDto(form.Name, form.Description, setAddress(defaultArg(form.Address, LocationAddress_get_empty())), form.ParentLocationId, form.BusinessUnitId)]), state.LocationId, state.BusinessUnits, state.Locations, state.AccountSettings, state.FormState), Cmd_none()];
    }
}

export function initNewLocationView() {
    return [new State(new RequestedValue$1(1, [emptyLocation]), undefined, new RequestedValue$1(0, []), new RequestedValue$1(0, []), new RequestedValue$1(0, []), FormState_get_empty()), Cmd_batch(ofArray([getAccountSettings((Item) => (new Msg(16, [Item])), (Item_1) => (new Msg(14, [Item_1]))), getResponsibleBusinessUnits((Item_2) => (new Msg(17, [Item_2])), (Item_3) => (new Msg(14, [Item_3]))), Cmd_OfPromise_either((url) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (fetchWithDecoder(0, addPrefix(url), singleton(new Types_RequestProperties(0, ["GET"])), "application/json", (response) => {
        const pr = response.arrayBuffer();
        return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), list_type(Location_$reflection())));
    })))), "/api/locations", (Item_4) => (new Msg(18, [Item_4])), (Item_5) => (new Msg(14, [Item_5])))]))];
}

export function initEditLocationView(locationId) {
    return [new State(new RequestedValue$1(0, []), locationId, new RequestedValue$1(0, []), new RequestedValue$1(0, []), new RequestedValue$1(0, []), FormState_get_empty()), Cmd_batch(ofArray([Cmd_OfPromise_either((url) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (fetchWithDecoder(0, addPrefix(url), singleton(new Types_RequestProperties(0, ["GET"])), "application/json", (response) => {
        const pr = response.arrayBuffer();
        return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), LocationDetailDto_$reflection()));
    })))), concat("/api/locations/", ...unwrapLocationId(locationId)), (Item) => (new Msg(11, [Item])), (Item_1) => (new Msg(14, [Item_1]))), getAccountSettings((Item_2) => (new Msg(16, [Item_2])), (Item_3) => (new Msg(14, [Item_3]))), getResponsibleBusinessUnits((Item_4) => (new Msg(17, [Item_4])), (Item_5) => (new Msg(14, [Item_5]))), Cmd_OfPromise_either((url_3) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (fetchWithDecoder(0, addPrefix(url_3), singleton(new Types_RequestProperties(0, ["GET"])), "application/json", (response_1) => {
        const pr_1 = response_1.arrayBuffer();
        return pr_1.then((blob_1) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob_1)), list_type(Location_$reflection())));
    })))), "/api/locations", (Item_6) => (new Msg(18, [Item_6])), (Item_7) => (new Msg(14, [Item_7])))]))];
}

export function update(msg, state) {
    let locationId_1, body_3, matchValue_7, xs, xs_2;
    switch (msg.tag) {
        case 1: {
            const matchValue_1 = state.Form;
            if (matchValue_1.tag === 0) {
                return [state, Cmd_none()];
            }
            else {
                const form_1 = matchValue_1.fields[0];
                return [new State(new RequestedValue$1(1, [new LocationCreateOrUpdateDto(form_1.Name, msg.fields[0], form_1.Address, form_1.ParentLocationId, form_1.BusinessUnitId)]), state.LocationId, state.BusinessUnits, state.Locations, state.AccountSettings, state.FormState), Cmd_none()];
            }
        }
        case 2:
            return updateAddress((address) => (new LocationAddress(msg.fields[0], address.AddressSupplement, address.ZipCode, address.City, address.Country)), state);
        case 3:
            return updateAddress((address_1) => (new LocationAddress(address_1.Street, msg.fields[0], address_1.ZipCode, address_1.City, address_1.Country)), state);
        case 4:
            return updateAddress((address_2) => (new LocationAddress(address_2.Street, address_2.AddressSupplement, msg.fields[0], address_2.City, address_2.Country)), state);
        case 5:
            return updateAddress((address_3) => (new LocationAddress(address_3.Street, address_3.AddressSupplement, address_3.ZipCode, msg.fields[0], address_3.Country)), state);
        case 6:
            return updateAddress((address_4) => (new LocationAddress(address_4.Street, address_4.AddressSupplement, address_4.ZipCode, address_4.City, map((country_1) => country_1.value.Code, msg.fields[0]))), state);
        case 9: {
            const matchValue_2 = state.Form;
            if (matchValue_2.tag === 0) {
                return [state, Cmd_none()];
            }
            else {
                return [new State(state.Form, state.LocationId, state.BusinessUnits, state.Locations, state.AccountSettings, FormState__startLoading(state.FormState)), Cmd_OfPromise_either((tupledArg) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                    let url_2;
                    return ((url_2 = addPrefix_1(tupledArg[0]), (refreshOn) => fetchWithDecoder_1(url_2, ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(2, [tupledArg[1]])]), "application/json", (response) => {
                        const pr = response.arrayBuffer();
                        return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), string_type));
                    }, refreshOn)))(true);
                })), ["/api/locations", toString(0, Auto_generateBoxedEncoder_437914C6(LocationCreateOrUpdateDto_$reflection(), undefined, undefined, undefined)(matchValue_2.fields[0]))], (Item) => (new Msg(12, [Item])), (Item_1) => (new Msg(15, [Item_1])))];
            }
        }
        case 10: {
            const matchValue_3 = state.Form;
            const matchValue_4 = state.LocationId;
            let matchResult, form_3, locationId;
            if (matchValue_3.tag === 1) {
                if (matchValue_4 != null) {
                    matchResult = 0;
                    form_3 = matchValue_3.fields[0];
                    locationId = matchValue_4;
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
            switch (matchResult) {
                case 0:
                    return [new State(state.Form, state.LocationId, state.BusinessUnits, state.Locations, state.AccountSettings, FormState__startLoading(state.FormState)), (locationId_1 = LocationId__get_unwrap(locationId), (body_3 = toString(0, Auto_generateBoxedEncoder_437914C6(LocationCreateOrUpdateDto_$reflection(), undefined, undefined, undefined)(form_3)), Cmd_OfPromise_either((tupledArg_1) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                        let url_5;
                        return ((url_5 = addPrefix_1(tupledArg_1[0]), (refreshOn_1) => fetchWithDecoder_1(url_5, ofArray([new Types_RequestProperties(0, ["PUT"]), new Types_RequestProperties(2, [tupledArg_1[1]])]), "application/json", (response_2) => {
                            const pr_1 = response_2.arrayBuffer();
                            return pr_1.then((blob_1) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob_1)), string_type));
                        }, refreshOn_1)))(true);
                    })), [concat("/api/locations/", ...locationId_1), body_3], (Item_2) => (new Msg(13, [Item_2])), (Item_3) => (new Msg(15, [Item_3])))))];
                default:
                    return [state, Cmd_none()];
            }
        }
        case 11: {
            const location_2 = msg.fields[0];
            return [new State(new RequestedValue$1(1, [new LocationCreateOrUpdateDto(location_2.Name, location_2.Description, location_2.Address, location_2.ParentLocationId, location_2.BusinessUnitId)]), state.LocationId, state.BusinessUnits, state.Locations, state.AccountSettings, state.FormState), Cmd_none()];
        }
        case 7: {
            const matchValue_6 = state.Form;
            if (matchValue_6.tag === 0) {
                return [state, Cmd_none()];
            }
            else {
                const form_4 = matchValue_6.fields[0];
                const businessUnitId = map((businessUnit_1) => businessUnit_1.value.Id, msg.fields[0]);
                return [new State(new RequestedValue$1(1, [new LocationCreateOrUpdateDto(form_4.Name, form_4.Description, form_4.Address, (matchValue_7 = state.Locations, (matchValue_7.tag === 0) ? form_4.ParentLocationId : filter((parentLocationId) => forAll((location_4) => Hierarchy_isInBusinessUnit(businessUnitId, location_4), toArray(tryFind((location_3) => (LocationId__get_unwrap(location_3.Id) === parentLocationId), matchValue_7.fields[0]))), form_4.ParentLocationId)), businessUnitId)]), state.LocationId, state.BusinessUnits, state.Locations, state.AccountSettings, state.FormState), Cmd_none()];
            }
        }
        case 8: {
            const matchValue_8 = state.Form;
            if (matchValue_8.tag === 0) {
                return [state, Cmd_none()];
            }
            else {
                const form_5 = matchValue_8.fields[0];
                return [new State(new RequestedValue$1(1, [new LocationCreateOrUpdateDto(form_5.Name, form_5.Description, form_5.Address, map((parentLocation_1) => LocationId__get_unwrap(parentLocation_1.value.Id), msg.fields[0]), form_5.BusinessUnitId)]), state.LocationId, state.BusinessUnits, state.Locations, state.AccountSettings, state.FormState), Cmd_none()];
            }
        }
        case 12: {
            const response_4 = msg.fields[0];
            if (response_4.tag === 1) {
                return [new State(state.Form, state.LocationId, state.BusinessUnits, state.Locations, state.AccountSettings, FormState__setValidationResponse_5219762A(state.FormState, response_4.fields[0])), Cmd_errorToast("validation.toast")];
            }
            else {
                return [new State(state.Form, state.LocationId, state.BusinessUnits, state.Locations, state.AccountSettings, FormState_get_empty()), Cmd_batch(ofArray([(xs = ["locations", response_4.fields[0]], Cmd_ofEffect((_arg) => {
                    RouterModule_nav(ofArray(xs), 1, 1);
                })), Cmd_successToast("location.location_saved_success")]))];
            }
        }
        case 13: {
            const response_5 = msg.fields[0];
            if (state.Form.tag === 0) {
                return [state, Cmd_none()];
            }
            else if (response_5.tag === 1) {
                return [new State(state.Form, state.LocationId, state.BusinessUnits, state.Locations, state.AccountSettings, FormState__setValidationResponse_5219762A(state.FormState, response_5.fields[0])), Cmd_errorToast("validation.toast")];
            }
            else {
                const matchValue_10 = state.LocationId;
                if (matchValue_10 == null) {
                    return [state, Cmd_errorToast("validation.toast")];
                }
                else {
                    const locationId_3 = matchValue_10;
                    return [new State(state.Form, state.LocationId, state.BusinessUnits, state.Locations, state.AccountSettings, FormState_get_empty()), Cmd_batch(ofArray([(xs_2 = ["locations", LocationId__get_unwrap(locationId_3)], Cmd_ofEffect((_arg_1) => {
                        RouterModule_nav(ofArray(xs_2), 1, 1);
                    })), Cmd_successToast("location.location_saved_success")]))];
                }
            }
        }
        case 14:
            return [new State(state.Form, state.LocationId, state.BusinessUnits, state.Locations, state.AccountSettings, FormState_get_empty()), Cmd_errorToast("storage.fail_fetch_data")];
        case 15:
            return [new State(state.Form, state.LocationId, state.BusinessUnits, state.Locations, state.AccountSettings, FormState_get_empty()), Cmd_errorToast("location.location_saved_error")];
        case 16:
            return [new State(state.Form, state.LocationId, state.BusinessUnits, state.Locations, new RequestedValue$1(1, [msg.fields[0]]), state.FormState), Cmd_none()];
        case 17:
            return [new State(state.Form, state.LocationId, new RequestedValue$1(1, [msg.fields[0]]), state.Locations, state.AccountSettings, state.FormState), Cmd_none()];
        case 18:
            return [new State(state.Form, state.LocationId, state.BusinessUnits, new RequestedValue$1(1, [msg.fields[0]]), state.AccountSettings, state.FormState), Cmd_none()];
        default: {
            const matchValue = state.Form;
            if (matchValue.tag === 0) {
                return [state, Cmd_none()];
            }
            else {
                const form = matchValue.fields[0];
                return [new State(new RequestedValue$1(1, [new LocationCreateOrUpdateDto(msg.fields[0], form.Description, form.Address, form.ParentLocationId, form.BusinessUnitId)]), state.LocationId, state.BusinessUnits, state.Locations, state.AccountSettings, state.FormState), Cmd_none()];
            }
        }
    }
}

